import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { NgxSpinnerService } from 'ngx-spinner';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Ativacao, Cliente, ResumoAtivacoes, User } from './../models/models';

@Injectable({
  providedIn: 'root',
})
export class AtivacoesService {
  public user: User;
  public ativacaoAtual: Ativacao | null;
  public clienteAtivacaoAtual: Cliente | null;
  public blockRead = false;
  public resumoAtivacoes: ResumoAtivacoes;
  public campanhaNameToFilter!: string | null;
  public eventsOnQueue: any[] = [];

  constructor(
    private afs: AngularFirestore,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
    private router: Router,
    private $gaService: GoogleAnalyticsService
  ) {}

  getLastAtivacaoPosicao(): Promise<number> {
    return new Promise(async (resolve) => {
      this.afs
        .collection(environment.DB_vendedores)
        .doc(this.user.email)
        .collection<Ativacao>(environment.DB_ativacoes, (ref) =>
          ref.orderBy('posicao', 'desc').limit(1)
        )
        .get()
        .subscribe((res) => {
          console.log(`Lendo do firestores:` + res.docs.length);
          if (!res.empty) {
            const last = res.docs[0].data() as Ativacao;
            resolve(last.posicao);
          }
          resolve(9999);
        });
    });
  }

  async enviarParaFinalDaFila(
    ativacao: Ativacao,
    messageId: string,
    user: User
  ) {
    this.spinner.show();
    const ultimaPosicao = await this.getLastAtivacaoPosicao();
    this.afs
      .collection(environment.DB_vendedores)
      .doc(ativacao.email_vendedor)
      .collection(environment.DB_ativacoes)
      .doc(ativacao.id_ativacao)
      .set(
        { posicao: ultimaPosicao + 1, message_id: messageId },
        { merge: true }
      )
      .then(async (res) => {
        this.ativacaoAtual = null;
        this.clienteAtivacaoAtual = null;

        if (user.status_bloqueio?.bloqueado) {
          this.router.navigateByUrl('');
        } else {
        }
        this.spinner.hide();
      });
  }

  incrementarAtivacoesRealizadasVendedor(
    ativacao: Ativacao,
    finalizada = false
  ) {
    this.afs
      .collection(environment.DB_vendedores)
      .doc(this.user.email)
      .get()
      .subscribe(async (res) => {
        this.afs
          .collection(environment.DB_vendedores)
          .doc(this.user.email)
          .collection(environment.DB_ativacoes)
          .doc<Ativacao>(ativacao.id_ativacao)
          .get()
          .subscribe(async (ativacaoData) => {
            console.log(`Lendo do firestores:` + res);
            const user = res.data() as User;
            const ativacaoInfo = ativacaoData.data() as Ativacao;
            console.log('Ativacao Info ------------------');
            console.log(ativacaoInfo);
            const index = user.resumoAtivacoes.campanhas.findIndex(
              (item) => item.campanha == ativacao.nome_campanha
            );

            if (!ativacaoInfo.finalizada || finalizada) {
              if (index >= 0) {
                user.resumoAtivacoes.campanhas[index].quantidade_ativada++;
                if (
                  user.resumoAtivacoes.campanhas[index].quantidade_aberta > 0
                ) {
                  user.resumoAtivacoes.campanhas[index].quantidade_aberta--;
                }
              }
              await res.ref.set(
                {
                  id_ultima_ativacao: ativacao.id_ativacao,
                  dt_ultima_ativacao: new Date(),
                  resumoAtivacoes: user.resumoAtivacoes,
                },
                { merge: true }
              );
              await ativacaoData.ref.set(
                {
                  finalizada: true,
                },
                { merge: true }
              );
            }
          });
      });
  }

  sendFinalizouAtivacaoEvent(ativacao: Ativacao) {
    this.$gaService.event('Finalizando ativação', 'Ativação');
    this.spinner.show();
    return of({});
  }

  finalizarContato(ativacao: Ativacao, user: User) {
    this.sendFinalizouAtivacaoEvent(ativacao).subscribe((res: any) => {
      this.afs
        .collection(environment.DB_vendedores)
        .doc(ativacao.email_vendedor)
        .collection(environment.DB_ativacoes)
        .doc(ativacao.id_ativacao)
        .set(
          {
            message_id: res.messageId,
            posicao: 99999,
            dt_finalizacao: new Date(),
            finalizada: true,
          },
          { merge: true }
        )
        .then(async () => {
          this.ativacaoAtual = null;
          this.clienteAtivacaoAtual = null;
          await this.incrementarAtivacoesRealizadasVendedor(ativacao, true);
          if (user.status_bloqueio?.bloqueado) {
            this.router.navigateByUrl('');
          } else {
            document.getElementById('content').scrollTo(0, 0);
          }
          this.spinner.hide();
        });
    });
  }

  executarAcaoContato(ativacao: Ativacao, messageId: string) {
    this.spinner.show();
    this.afs
      .collection(environment.DB_vendedores)
      .doc(ativacao.email_vendedor)
      .collection(environment.DB_ativacoes)
      .doc(ativacao.id_ativacao)
      .set(
        {
          message_id: messageId,
          executou_acao: true,
          dt_ultima_acao_executada: new Date(),
        },
        { merge: true }
      )
      .then(() => {
        ativacao.executou_acao = true;
        this.spinner.hide();
      });
  }
}
